var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeojectDetailsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 20 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L15.8333 15.8333L2 29.6667",
    stroke: "#E4B200",
    strokeWidth: 4.61111
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeojectDetailsArrow);
export default __webpack_public_path__ + "static/media/PeojectDetailsArrow.86ed4b94f81a8e84f72dd6915b30d505.svg";
export { ForwardRef as ReactComponent };